import { Component, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';

@Component({
  selector: 'ocp-create-account-form',
  templateUrl: './create-account-form.component.html',
  styleUrls: ['./create-account-form.component.scss'],
  imports: [HlmButtonImports, HlmCardImports, TranslatePipe, ThemedIconComponent],
})
export class CreateAccountFormComponent {
  allplanId = output();
  graphisoftId = output();
  signIn = output();
}
